import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

export default function SaveButton({ onClick }) {
  return (
    <Grid item xs={12}>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          onClick={onClick}
          sx={{
            px: 4,
            py: 1.5,
          }}
        >
          Salvar configurações
        </Button>
      </Box>
    </Grid>
  );
}
